// service统一出口
import HTTPRequest from '..'
import { local } from '@/utils/storage'
import permissionHeader from '@/utils/permissionHeader'

const httpRequest = new HTTPRequest({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT,
  // 跨域请求携带 cookie；需后端同时返回 Access-Control-Allow-Credentials: true，
  // 且 Access-Control-Allow-Origin 为具体前端域名（不能是 *）
  withCredentials: true,
  interceptors: {
    requestInterceptor: (config) => {
      config.headers.token = config?.specialToken || local.get('TOKEN')
      config.headers = {
        ...permissionHeader(),
        ...config.headers
      }
      if (config.headers.ownerType == 0) {
        config.headers.teamId = ''
      }
      return config
    },
    requestInterceptorCatch: (err) => {
      return err
    },
    responseInterceptor: (res) => {
      return res
    },
    responseInterceptorCatch: (err) => {
      return err
    }
  }
})

export default httpRequest
